const baseURL = 'https://multi-catalogo.encatalogo.com';

export default baseURL;
